import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdobeService } from 'src/app/services/adobe.service';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {

	initialLoad = true;
	loading = true;
	requestSent = false;
	view = 'form';

	form!: UntypedFormGroup;
	signatures: any[] = [];
	//userSignatures = [];
	//showForm = true;
	//showPrevious = false;
	errorResponse = '';
	signatureRequestExpired = false;

	attachments: any[] = [];
	internalUsers: any[] = [];

	signerId = 0;

	authCode = '';
	authError = false;
	startedDropboxSignAuth = false;

	templates = [];
	selectedTemplate = '';

	showDragDropBorder: boolean = false;

	projectConfigs: any = {};

	showHelp = false;
	showConfigure = false;
	showCreateNewRequest = false;
	showAttachmentsExpanded = false;
	showOptionsExpanded = false;
	showSignersExpanded = true;
	showAllRequests = false;

	authMessage = '';

	isSubmittal = false;
	isSubmittalManager = false;

	isRfi = false;
	isRfiManager = false;

	isSigner = false;
	hasBallInCourt = false;

	showReminders = false;
	reminderMessage = '';
	reminders = [];

	openRequest = false;

	folders = [];
	folderOptions = [];

	// File Vars
	uploadedDoc: any;
	useGeneratedFile = false;

	constructor(
		private fb: UntypedFormBuilder,
		private adobeService: AdobeService,
		private clientService: ClientService,
		public contextService: ContextService,
		private procoreService: ProcoreService
	) { }

	ngOnInit() {
		// This is because the configs are stored in a name value pair, this transforms them into a usable state
		this.setDefaultProjectConfigs();
		for (const config of this.contextService.clientDetailProcore.projectConfigs) {
			console.log(config.configName);
			if (config.configName === 'allowDefaultLocationOverride') {
				console.log(config.configValue);
				this.projectConfigs[config.configName] = config.configValue === 'true';
				console.log(this.projectConfigs[config.configName]);
			} else {
				this.projectConfigs[config.configName] = config.configValue;
			}
		}

		this.initForm();

		this.retrieveFolders();
		this.retrieveUsers();
		this.retrieveSignatures();

		if (this.contextService.clientDetailProcore.enableMultipleAttachments) {
			this.retrieveAttachments();
		} else {
			this.attachments = [];
		}


		//  this.procoreService.getReminders(this.contextObj.context.company_id, this.signature.signatureRequestId).subscribe((result: any[]) => {
		// 	 this.reminders = result;
		//  });
	}

	reInit() {
		this.loading = true;

		this.requestSent = false;

		this.showAttachmentsExpanded = false;
		this.showSignersExpanded = true;
		this.showOptionsExpanded = false;
		this.showCreateNewRequest = false;
		this.showHelp = false;
		this.showConfigure = false;
		this.showAllRequests = false;

		this.initForm();

		this.retrieveSignatures();
	}

	/** INIT FUNCTIONS **/

	initForm() {
		this.form = this.fb.group({
			companyId: ['', []],
			projectId: ['', []],
			fileId: ['', []],
			userId: ['', []],
			itemId: ['', []],
			view: ['', []],
			sentOn: [formatDate(new Date(), 'yyyy-MM-dd', 'en'), []],
			allowDecline: [false, []],
			allowReassign: [false, []],
			expirationDate: ['', []],
			dateOffset: [new Date().getTimezoneOffset(), []],
			fileLocation: ['default', []],
			signersList: this.fb.array([]),
			title: ['Embedded Signing Test', []],
			subject: ['Embedded Signing Test', []],
			message: ['This is a test', []],
			requesterEmail: [this.contextService.procoreUserInfo.email, []],
			ccEmails: ['', []]
		});
		this.signerId = 0;

		this.setFormFromContext();
	}

	setFormFromContext() {
		this.form.controls['companyId'].setValue(this.contextService.procoreContextObject.context.company_id, { emitEvent: true });
		this.form.controls['projectId'].setValue(this.contextService.procoreContextObject.context.project_id, { emitEvent: true });
		this.form.controls['fileId'].setValue(this.contextService.procoreContextObject.context.file_id, { emitEvent: true });
		this.form.controls['userId'].setValue(this.contextService.procoreContextObject.context.user_id, { emitEvent: true });
		this.form.controls['itemId'].setValue(this.contextService.procoreContextObject.context.id, { emitEvent: true });
		this.form.controls['view'].setValue(this.contextService.procoreContextObject.context.view, { emitEvent: true });
	}

	retrieveAttachments() {
		this.procoreService.getAttachments(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreContextObject.context.view, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
			const files = result;
			for (const file of files) {
				file.checked = false;
			}
			this.attachments = files;
		});
	}

	retrieveFolders() {
		this.procoreService.getProjectFolders(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((folders: any[]) => {
			this.folders = folders;
			for (const folder of this.folders) {
				this.populateFolderOptions(folder, 0);
			}

			this.form.controls['fileLocation'].setValue(this.getDefaultFileLocation(), { emitEvent: true });
		});
	}

	retrieveSignatures() {
		this.clientService.getSignaturesByProcoreContext(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreUserInfo.email)
			.subscribe((signaturesResult: any) => {
				this.signatures = signaturesResult;
				console.log(signaturesResult);
				//if (this.signatures.length > 0) {
				// 	// This assumes the order is always correct.
				// 	// Set the top entry to the signature.


				// Set the main signature
				//const signatureResult = this.signatures[0];
				//this.signature = signatureResult.clientSignature;

				// 	// Set if its expired
				// 	if (this.signature.signatureExpirationDate) {
				// 		const expirationDate = new Date(this.signature.signatureExpirationDate);
				// 		if (new Date() > expirationDate) {
				// 			this.signatureRequestExpired = true;
				// 		}
				// 	}

				// if (signatureResult.participants) {
				// 	this.userSignatures
				// }

				// 	// This defaults the signers on the form in case of an edit
				// 	if (signatureResult.signatures) {
				// 		this.userSignatures = signatureResult.signatures;
				// 		for (const signatureInfo of signatureResult.signatures) {
				// 			let isInternal = false;
				// 			for (const internalUser of this.internalUsers) {
				// 				if (signatureInfo.signer_email_address === internalUser.email) {
				// 					this.addSigner('internal', '');
				// 					this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
				// 					isInternal = true;
				// 					break;
				// 				}
				// 			}
				// 			if (!isInternal) {
				// 				this.addSigner('external', '');
				// 				this.updateExternalSigner(signatureInfo.signer_email_address, signatureInfo.signer_name, this.form.getRawValue()['signersList'].length - 1);
				// 			}
				// 			this.existingSignatories.push({
				// 				'name': signatureInfo.signer_name,
				// 				'email': signatureInfo.signer_email_address,
				// 				'status': signatureInfo.status_code,
				// 				'viewedAt': signatureInfo.last_viewed_at
				// 			});
				// 		}
				// 	}


				//}
				this.loading = false;
				this.initialLoad = false;
			});
	}

	retrieveTemplates() {
		// this.procoreService.getTemplates(this.contextObj.context.company_id, this.userInfo?.email).subscribe((result) => {
		// 	this.templates = result;
		// });
	}

	retrieveUsers() {
		this.procoreService.getUsers(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
			this.internalUsers = result;
		});
	}


	/** FILE FUNCTIONS **/

	setUploadedDoc(uploadedDoc) {
		this.uploadedDoc = uploadedDoc;
	}

	setUseGeneratedFile(useGeneratedFile) {
		this.useGeneratedFile = useGeneratedFile;
	}


	/** SIGNER FUNCTIONS **/

	addSigner(type: string, role: string) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		if (!role) {
			role = 'Signer' + (this.signerId + 1);
		}

		signers.push(this.fb.group({
			signerType: [type, []],
			signerId: [this.signerId, [, Validators.email]],
			signerEmail: [null, [, Validators.email]],
			signerName: ['', []],
			role: [role, []]
		}, {
			validators: [
				this.checkSigner()
			]
		}));

		this.signerId = this.signerId + 1;
	}

	checkSigner() {
		return (group: UntypedFormGroup) => {
			let signerValid = true;
			if (this.form) {
				if (group.value.signerType === 'external') {
					signerValid = group.value.signerEmail && group.value.signerName;
				} else {
					signerValid = group.value.signerEmail;
				}
			}

			if (signerValid) {
				group.controls['signerId'].setErrors(null);
				group.controls['signerEmail'].setErrors(null);
				group.controls['signerName'].setErrors(null);
				return '';
			} else {
				if (group.value.signerType === 'external') {
					group.controls['signerEmail'].setErrors(Validators);
					group.controls['signerName'].setErrors(Validators);
				} else {
					group.controls['signerId'].setErrors(Validators);
				}
				return {
					missing: true
				};
			}
		};
	}

	removeSigner(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		signers.removeAt(i);
	}

	trackSigners(i: number, signer: any) {
		return signer.signerId;
	}

	updateInternalSigner(e: any, i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		const signer: any = signers.at(i);
		signer.controls.signerEmail.setValue(e.email, { emitEvent: true });
		signer.controls.signerName.setValue(e.name, { emitEvent: true });
	}

	updateExternalSigner(email: string, name: string, i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		const signer: any = signers.at(i);
		signer.controls.signerEmail.setValue(email, { emitEvent: true });
		signer.controls.signerName.setValue(name, { emitEvent: true });
	}

	moveSignerUp(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		const signer = signers.at(i);
		signers.removeAt(i);
		signers.insert(i - 1, signer);
	}

	moveSignerDown(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		const signer = signers.at(i);
		signers.removeAt(i);
		signers.insert(i + 1, signer);
	}


	/** SUBMIT **/

	submit() {
		this.loading = true;
		const requestBody = this.form.getRawValue();
		console.log(requestBody);
		if (this.selectedTemplate) {
			requestBody['templateId'] = this.selectedTemplate;
			for (const template of this.templates) {
				if (template.template_id === this.selectedTemplate) {
					requestBody['templateName'] = template.title;
					break;
				}
			}
		}
		if (this.useGeneratedFile) {
			requestBody['useGeneratedFile'] = true;
		}
		requestBody.attachments = [];
		for (const attachment of this.attachments) {
			if (attachment.checked) {
				requestBody.attachments.push(attachment.url);
			}
		}

		this.adobeService.createAdobeAuthoringAgreement(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe((result: string) => {
				console.log(result);

				window.open(result, '_blank');

				this.requestSent = true;
				this.loading = false;

				// TODO: Show a success message or that status window?
			}, (error) => {

				this.loading = false;
			});
	}


	/** OTHER ACTIONS **/

	cancelAndResend() {
		this.loading = true;
		// const requestBody = this.form.getRawValue();
		// requestBody['signatureRequestId'] = this.signature.signatureRequestId;
		// requestBody['user_name'] = this.contextService.procoreUserInfo ? this.contextService.procoreUserInfo.email : '';

		// this.procoreService.cancel(requestBody, this.isSandbox).subscribe((result: any) => {
		// 	this.submit();
		// });
	}

	requestCancelled(signature) {
		let item = this.signatures.find(d => d === signature);
		console.log(item);
		if (item && item.clientSignature.status == 'DRAFT') {
			console.log('remove it');
			this.signatures.splice(this.signatures.indexOf(item), 1);
		} else {
			console.log('cancel it');
			item.clientSignature.status = 'CANCELLED';
			item.participants = null;
		}
		console.log(this.signatures);

		// If there is only one remaining signature, show the correct buttons
		if (this.signatures.length == 1) {
			this.showAllRequests = false;
		}
	}




	/** REMINDERS **/

	sendReminder() {
		// if (this.signature) {
		// 	this.loading = true;

		// 	let signerEmail = '';
		// 	for (const signer of this.signatures[0].signatures) {
		// 		if (signer.status_code === 'awaiting_signature') {
		// 			signerEmail = signer.signer_email_address;
		// 			break;
		// 		}
		// 	}

		// 	if (signerEmail) {
		// 		// this.procoreService.sendReminder(this.contextObj.context.company_id, this.signature.signatureRequestId, signerEmail, this.userInfo?.email).subscribe((result: any) => {
		// 		// 	this.reminderMessage = result.reminderMessage;
		// 		// 	this.reminders = result.reminders;
		// 		// 	this.loading = false;
		// 		// });
		// 	} else {
		// 		this.loading = false;
		// 	}
		// }
	}


	/** HELPER FUNCTIONS **/

	populateFolderOptions(folder: any, depth: number) {
		this.folderOptions.push({
			id: folder.id,
			name: '-'.repeat(depth) + folder.name
		});
		if (folder.children) {
			for (const child of folder.children) {
				this.populateFolderOptions(child, depth + 1);
			}
		}
	}

	getDefaultFileLocation() {
		let location = 'default';
		let configName = '';

		if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts.potential_change_orders') > -1) {
			configName = 'primeContractPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts.change_orders') > -1) {
			configName = 'primeContractCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts') > -1) {
			configName = 'primeContractStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts.potential_change_orders') > -1) {
			configName = 'subcontractPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts.change_orders') > -1) {
			configName = 'subcontractCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts') > -1) {
			configName = 'subcontractStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts.potential_change_orders') > -1) {
			configName = 'purchaseOrderPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts.change_orders') > -1) {
			configName = 'purchaseOrderCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts') > -1) {
			configName = 'purchaseOrderStorage';
		}

		if (configName && this.projectConfigs[configName]) {
			location = this.projectConfigs[configName];
		}

		return location;
	}

	getDefaultFileLocationLabel() {
		let label = '';

		if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts') > -1) {
			label = 'Attach to Prime Contract';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts') > -1) {
			label = 'Attach to Subcontract';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts') > -1) {
			label = 'Attach to Purchase Order';
		}

		return label;
	}

	setDefaultProjectConfigs() {
		this.projectConfigs = {
			allowDefaultLocationOverride: false,
			primeContractStorage: 'default',
			primeContractCoStorage: 'default',
			primeContractPcoStorage: 'default',
			subcontractStorage: 'default',
			subcontractCoStorage: 'default',
			subcontractPcoStorage: 'default',
			purchaseOrderStorage: 'default',
			purchaseOrderCoStorage: 'default',
			purchaseOrderPcoStorage: 'default'
		};
	}

	showConfigureForm() {
		this.showConfigure = true;
	}

	exitConfiguration() {
		this.showConfigure = false;
	}

	getExpirationMinDate() {
		const date = new Date();
		date.setDate(date.getDate() + 1);
		const year = date.getFullYear();
		let month: any = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		let day: any = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		return year + '-' + month + '-' + day;
	}

	getExpirationMaxDate() {
		const date = new Date();
		date.setDate(date.getDate() + 90);
		const year = date.getFullYear();
		let month: any = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		let day: any = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		return year + '-' + month + '-' + day;
	}

	/** UNUSED FUNCTIONS **/

	// canSetAccountType() {
	// 	let canSet = false;

	// 	if (this.contextService.clientDetailProcore) {
	// 		if (this.contextService.clientDetailProcore.dropboxSignAccountType === 'OAUTHG' || this.contextService.clientDetailProcore.dropboxSignAccountType === 'OAUTH') {
	// 			canSet = this.contextService.clientDetailProcore.dropboxSignClientId && this.contextService.clientDetailProcore.dropboxSignOAUTHClientSecret;
	// 		} else if (this.contextService.clientDetailProcore.dropboxSignAccountType === 'API') {
	// 			canSet = this.contextService.clientDetailProcore.dropboxSignClientId && this.contextService.clientDetailProcore.dropboxSignAPIKey;
	// 		}
	// 	}

	// 	return canSet;
	// }

	// downloadFile(signature: any) {
	// 	console.log(signature);
	// 	signature.companyId = this.form.getRawValue()['companyId'];
	// 	signature.projectId = this.form.getRawValue()['projectId'];
	// 	signature.itemId = this.form.getRawValue()['itemId'];

	// 	if (this.form.getRawValue()['view'] === 'rfi.detail' || this.form.getRawValue()['view'] === 'submittal_logs.detail' || this.form.getRawValue()['view'] === 'inspections.detail' || this.form.getRawValue()['view'] === 'correspondence.detail') {
	// 		if (this.userInfo) {
	// 			this.procoreService.getSignatureRequestFile(signature, this.userInfo.email).subscribe((result: any) => {
	// 				saveAs(result, signature.filename);
	// 			});
	// 		} else {
	// 			this.procoreService.getUserInfo(this.form.getRawValue()['companyId'], this.authCode, this.isSandbox).subscribe((result: any) => {
	// 				this.userInfo = result;
	// 				this.procoreService.getSignatureRequestFile(signature, this.userInfo.email).subscribe((result: any) => {
	// 					saveAs(result, signature.filename);
	// 				});
	// 			});
	// 		}
	// 	} else {
	// 		this.procoreService.getFile(signature, this.isSandbox, this.form.getRawValue()['view']).subscribe((result: any) => {
	// 			if (result) {
	// 				window.open(result, '_blank');
	// 			}
	// 		});
	// 	}
	// }

	// loadSubmittal() {
	// 	if (this.signature) {
	// 		this.procoreService.getSignatureRequest(this.contextService.procoreContextObject.context.company_id, this.signature.signatureRequestId, this.contextService.procoreUserInfo.email).subscribe((signatureRequest: any) => {
	// 			for (const signer of signatureRequest.signatures) {
	// 				if (signer.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 					this.isSigner = true;
	// 					break;
	// 				}
	// 			}
	// 		});
	// 	}
	// 	this.procoreService.getSubmittal(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreIsSandbox).subscribe((submittal: any) => {
	// 		this.isSubmittalManager = submittal.submittal_manager.login === this.contextService.procoreUserInfo.email;
	// 		if (this.signature) {
	// 			// for (const user of submittal.ball_in_court) {
	// 			// 	if (user.login === this.userInfo.email) {
	// 			// 		this.hasBallInCourt = true;
	// 			// 		break;
	// 			// 	}
	// 			// }
	// 			for (const signature of this.userSignatures) {
	// 				if (signature.status_code === 'awaiting_signature' && signature.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 					this.hasBallInCourt = true;
	// 					break;
	// 				}
	// 			}
	// 		} else {
	// 			for (const approver of submittal.approvers) {
	// 				this.addSigner('internal', '');
	// 				const internalUser = {
	// 					email: approver.user.login,
	// 					name: approver.user.name
	// 				};
	// 				this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
	// 			}
	// 		}
	// 		console.log(submittal);
	// 		this.initialLoad = false;
	// 		this.loading = false;
	// 	});
	// }

	// loadRfi() {
	// 	this.procoreService.getRfi(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreIsSandbox).subscribe((rfi: any) => {
	// 		this.isRfiManager = rfi.rfi_manager.login === this.contextService.procoreUserInfo.email;
	// 		if (!this.signature || this.signature.status === 'CANCELLED') {
	// 			for (const assignee of rfi.assignees) {
	// 				this.addSigner('internal', '');
	// 				const internalUser = {
	// 					email: assignee.login,
	// 					name: assignee.name
	// 				};
	// 				this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
	// 			}
	// 		}
	// 		console.log(rfi);
	// 		this.initialLoad = false;
	// 		this.loading = false;
	// 	});
	// }

	// templateSelected(e: any) {
	// 	while (this.form.getRawValue()['signersList'].length > 0) {
	// 		this.removeSigner(0);
	// 	}

	// 	const templateId = e.target.value;
	// 	if (templateId) {
	// 		for (const template of this.templates) {
	// 			if (template.template_id === templateId) {
	// 				for (const role of template.signer_roles) {
	// 					this.addSigner('external', role.name);
	// 				}
	// 				break;
	// 			}
	// 		}
	// 	}
	// }

	// signSignatureRequest() {
	// 	let signatureRequestId: string;

	// 	for (const signature of this.userSignatures) {
	// 		if (signature.status_code === 'awaiting_signature' && signature.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 			signatureRequestId = signature.signature_id;
	// 			break;
	// 		}
	// 	}

	// 	if (signatureRequestId) {
	// 		this.procoreService.getSignatureRequestSignUrl(this.contextObj.context.company_id, signatureRequestId, this.userInfo.email).subscribe((result: any) => {
	// 			window.open('/?embedded-sign=1&url=' + btoa(result.url) + '&clientId=' + result.clientId, '_blank');
	// 		});
	// 	}
	// }

	// submitSignatureRequest() {
	// 	this.loading = true;
	// 	const requestBody = this.form.getRawValue();
	// 	requestBody['templateId'] = this.selectedTemplate;
	// 	requestBody.attachments = [];
	// 	for (const attachment of this.attachments) {
	// 		if (attachment.checked) {
	// 			requestBody.attachments.push(attachment.url);
	// 		}
	// 	}

	// 	this.procoreService.createEmbeddedSignatureRequest(this.uploadedDoc, requestBody, this.isSandbox).subscribe((result: string) => {
	// 		console.log(result);
	// 		this.requestSent = true;
	// 		this.loading = false;
	// 	});
	// }

}
